import PageWrapper from "@/pages/PageWrapper";
import Hero from "@/sections/Hero";
import FeaturedKerala from "@/sections/FeaturedKerala";
import Stats from "@/sections/Stats";
import CTABanner from "@/sections/CTABanner";
import useSEO from "@/lib/useSEO";

export default function Home({ introDone }) {
    useSEO({
        title: "ate.teen studio — Architecture, Interior & Construction Studio in Kollam, Kerala",
        description:
            "Kollam-based architecture studio designing luxury villas, cultural spaces, showrooms and public landscapes across Kerala. Featured work: Monsoon Villa, Casa Terra, Rithanya Natya Kshetra and more.",
        path: "/",
    });
    return (
        <PageWrapper>
            <Hero introDone={introDone} />
            <FeaturedKerala />
            <Stats />
            <CTABanner />
        </PageWrapper>
    );
}
